/**
 * Kestirimci bakim tablosunun satirlari.
 *
 * ## Yanit PARALEL DIZILERDEN olusuyor
 *
 * `/api/predictivemaintenance/listbyuid` dort ayri dizi donduruyor --
 * `ioList`, `description`, `productList`, `predictTime` -- ve hepsi ayni
 * `index` ile okunuyor. Eski arayuz kodu `ioList` uzerinde donup digerlerini
 * dogrudan indeksliyordu:
 *
 * ```
 * tableOfReparation["productList"][index]["brand"]
 * ```
 *
 * Diziler ayrisirsa `productList[index]` `undefined` olur ve `["brand"]`
 * okumak TypeError atar: SAYFA BEYAZ kalir. Sunucu tarafi 2026-10-16'da dort
 * listeyi birlikte kuracak sekilde duzeltildi (tanimsiz `deviceTimeType`
 * degerleri urun listesine girmiyor ama io listesinden de silinmiyordu), yani
 * ayrisma artik yapisal olarak mumkun degil.
 *
 * Buradaki koruma yine de duruyor: arayuz, bozuk bir yanit yuzunden COKMEMELI.
 * En kotu durumda eksik satir gosterir.
 *
 * ## `predictTime` null olabilir
 *
 * Bu da KASITLI: urunun azami kullanim suresi girilmemis ya da sifirsa sunucu
 * yuzdeyi hesaplayamiyor ve null donduruyor (P2-8; oncesinde Infinity donup
 * gecersiz JSON uretiyordu). Eski arayuz dogrudan `.toFixed(4)` cagiriyordu,
 * yani azami suresi girilmemis bir urun sayfayi patlatiyordu.
 */

export type KestirimSatiri = {
  aciklama: string
  input: string
  marka: string
  model: string
  /** Kullanim yuzdesi; hesaplanamiyorsa null. */
  yuzde: number | null
  azamiSure: number | null
  sureTipi: string
}

/** Sunucudan gelen paralel dizileri satirlara cevirir. */
export function kestirimSatirlari(yanit: any): KestirimSatiri[] {
  const ioList = Array.isArray(yanit?.["ioList"]) ? yanit["ioList"] : []
  const description = Array.isArray(yanit?.["description"]) ? yanit["description"] : []
  const productList = Array.isArray(yanit?.["productList"]) ? yanit["productList"] : []
  const predictTime = Array.isArray(yanit?.["predictTime"]) ? yanit["predictTime"] : []

  // Dordunun de girdisi olan satir sayisi.
  const adet = Math.min(ioList.length, description.length, productList.length, predictTime.length)

  const satirlar: KestirimSatiri[] = []
  for (let i = 0; i < adet; i++) {
    const urun = productList[i]
    if (!urun) {
      continue
    }
    const yuzde = predictTime[i]
    const azami = urun["maxUsageTime"]
    satirlar.push({
      aciklama: description[i] ?? '-',
      input: ioList[i] ?? '-',
      marka: urun["brand"] ?? '-',
      model: urun["model"] ?? '-',
      yuzde: typeof yuzde === 'number' && Number.isFinite(yuzde) ? yuzde : null,
      azamiSure: typeof azami === 'number' ? azami : null,
      sureTipi: String(urun["deviceTimeType"] ?? ''),
    })
  }
  return satirlar
}

/** Yuzde metni. Hesaplanamayan yuzde "-" olarak yaziliyor, "NaN%" degil. */
export function yuzdeMetni(yuzde: number | null): string {
  if (yuzde === null || !Number.isFinite(yuzde)) {
    return '-'
  }
  if (yuzde > 100) {
    return '100%+'
  }
  return yuzde.toFixed(2) + '%'
}

/** Ilerleme cubugunun genisligi. */
export function cubukGenisligi(yuzde: number | null): string {
  if (yuzde === null || !Number.isFinite(yuzde) || yuzde < 0) {
    return '0%'
  }
  return Math.min(yuzde, 100).toFixed(2) + '%'
}

/**
 * Azami kullanim suresinin birimi.
 *
 * Eskiden tanimsiz tipte `undefined` donuyordu ve `sayi + undefined` ekranda
 * "NaN" yaziyordu.
 */
export function sureBirimi(tip: string): string {
  if (tip === '2') return ' tetik'
  if (tip === '3') return ' saat'
  if (tip === '4') return ' kg'
  return ''
}
